export enum BffQueryKey {
    ORDER_CONFIRMATION = 'bff_order_confirmation',
    BASKET = 'bff_basket',
    BASKET_AVAILABILITY = 'bff_basket_availability',
    BASKET_INVENTORY = 'bff_basket_inventory',
    CUSTOMER = 'bff_customer',
    CUSTOMER_SAVE_FOR_LATER = 'bff_customer_save_for_later',
    CUSTOMER_WISH_LISTS = 'bff_customer_wish_lists',
    CUSTOMER_CONTEXT = 'bff_customer_context',
    EDD = 'bff_edd',
    STORE = 'bff_store',
    BUILD_STATUS = 'build_status',
    SEARCH = 'search',
    PAYMENT_METHODS = 'bff_payment_methods',
    SHIPPING_METHODS = 'bff_shipping_methods',
    PRODUCT = 'bff_product',
    PRODUCTS = 'bff_products',
    SHIPPING_OPTIONS = 'bff_shipping_options',
    STORE_BOPIS_INVENTORY = 'bff_store_bopis_inventory',
    STORE_SDD_INVENTORY = 'bff_store_sdd_inventory',
    TURN_TO_DATA = 'turn_to_product_data',
    TURN_TO_QUESTIONS = 'turn_to_questions',
    TURN_TO_BULK_SUMMARY = 'turn_to_bulk_summary',
    BLOOMREACH_RECOMMENDATION = 'bloomreach_recommendation',
    BLOOMREACH_WIDGETS = 'bloomreach_widgets',
    CATEGORIES = 'categories',
    RELATED_PAGES = 'optiversal_related_pages',
    CONTENT = 'content',
    USID = 'usid',
    CONTENT_ASSET = 'content_asset',
}
